import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { global } from "../../Context/Context";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInterceptor";

const BaseUrl = process.env.REACT_APP_BASEURL3;

const AppHost = (props) => {
  const { aprrovedHost } = useContext(global);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [currentUsers, setCurrentUsers] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch hosts
  const fetchHostsByStatus = async (status, page, limit, search = "") => {
    setLoading(true);
    setCurrentUsers([]);
    try {
      let url = `${BaseUrl}/agency/host/gethost?status=${status}&page=${page}&limit=${limit}`;
      if (search) url = `${BaseUrl}/agency/host/gethostsearch?status=${status}&page=${page}&limit=${limit}` + `&search=${search}`;
      const res = await axiosInstance.get(url);
      if (res.data.success == 1) {
        toast.success(res.data.message);
        setTotalPages(res.data.pages || 1);
        setTotalEntries(res.data.total || 0);
        setCurrentUsers(res.data.details);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err.message);
    }
    setLoading(false);
  };

  // On mount and page/status/limit/search change
  useEffect(() => {
    fetchHostsByStatus(props.status, currentPage, entriesPerPage, searchQuery);
    // eslint-disable-next-line
  }, [props.status, currentPage, entriesPerPage]);

  // Search triggered only on Go click
  const handleGoSearch = () => {
    setCurrentPage(1);
    setSearchQuery(searchInput.trim());
    fetchHostsByStatus(props.status, 1, entriesPerPage, searchInput.trim());
  };

  // Pagination
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchHostsByStatus(props.status, pageNumber, entriesPerPage, searchQuery);
  };

  // Animations
  const tableRowStyle = {
    animation: "fadeIn 0.6s cubic-bezier(.4,0,.2,1)"
  };

  // Serial number for the first row
  const startingSrNo = totalEntries - (currentPage - 1) * entriesPerPage;

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(16px);}
          to { opacity: 1; transform: translateY(0);}
        }
        .search-bar-animated {
          transition: box-shadow 0.3s;
          border-radius: 24px;
        }
        .search-bar-animated:focus {
          box-shadow: 0 0 0 2px #2ca8ff;
        }
        .go-btn {
          background: linear-gradient(90deg, #2ca8ff, #90caf9);
          border: none;
          color: #fff;
          border-radius: 20px;
          padding: 8px 26px;
          font-weight: 500;
          transition: background .2s;
          margin-left: 8px;
        }
        .go-btn:hover {
          background: linear-gradient(90deg, #1e7fd7, #64b5f6);
        }
        .table-striped > tbody > tr:nth-child(odd) { background: #f8fafd; }
        .table-striped > tbody > tr:nth-child(even) { background: #eef4fa; }
      `}</style>
      <section className="content-header">
        <h1>Host List</h1>
        <ol className="breadcrumb">
          <li><Link to="/admin"><i className="fa fa-dashboard"></i> Home</Link></li>
          <li className="active">Host List</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-xs-12">
            <div className="box">
              <div className="box-body">
                <div className="row " style={{ padding: "16px 0px" }}>
                  <div className="entries-per-page col-md-6 ">
                    <label htmlFor="entries">Entries per page:</label>
                    <select
                      id="entries"
                      value={entriesPerPage}
                      onChange={e => {
                        setEntriesPerPage(parseInt(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                    </select>
                  </div>
                  <div className="col-md-5" style={{ display: "flex", justifyContent: "center" }}>
                    <div className="main-data-single-field" style={{ width: "fit-content" }}>
                      <span style={{ fontWeight: "bold", marginRight: "8px" }}>Search</span>
                      <input
                        type="text"
                        className="form-control search-bar-animated"
                        style={{ width: "170px", display: "inline-block" }}
                        value={searchInput}
                        onChange={e => setSearchInput(e.target.value)}
                        onKeyDown={e => { if (e.key == "Enter") handleGoSearch(); }}
                        placeholder="Username or Agency Code"
                      />
                      <button className="go-btn" onClick={handleGoSearch}>Go</button>
                    </div>
                  </div>
                </div>
                <div style={{ minHeight: 40 }}>
                  {loading && <div style={{ textAlign: "center", fontWeight: 500 }}>Loading...</div>}
                </div>
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sr.</th>
                      <th>Date</th>
                      <th>Username</th>
                      <th>Real name</th>
                      <th>Phone</th>
                      <th>Agency Code</th>
                      <th>Agency Name</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.length == 0 && !loading && (
                      <tr><td colSpan={9} style={{ textAlign: "center" }}>No data found</td></tr>
                    )}
                    {currentUsers.map((item, index) => (
                      <tr key={item._id} style={tableRowStyle}>
                        <td>{startingSrNo - index}</td>
                        <td>{new Date(item?.createdAt).toLocaleString()}</td>
                        <td>{item?.username}</td>
                        <td>{item?.realName}</td>
                        <td>{item?.number}</td>
                        <td>{item?.agencyCode}</td>
                        <td>{item?.agencyName}</td>
                        <td>
                          {item.status == "0" ? (
                            <span className="label label-info">Pending</span>
                          ) : item.status == "1" ? (
                            <span className="label label-success">Approved</span>
                          ) : (
                            <span className="label label-danger">Rejected</span>
                          )}
                        </td>
                        <td>
                          <ul className="admin-action btn btn-default" style={{ backgroundColor: "#f4f4f4", color: "#fff !important" }}>
                            <li className="dropdown">
                              <a className="dropdown-toggle" style={{ color: "black" }} data-toggle="dropdown" href="#" aria-expanded="false">
                                Action  
                              </a>
                              <ul className="dropdown-menu dropdown-menu-right">
                                {item?.status == 0 && (
                                  <>
                                    <li role="presentation" onClick={() => aprrovedHost({ id: item._id, status: "1" })}>
                                      <Link role="menuitem" tabIndex={-1} to="">Approve</Link>
                                    </li>
                                    <li role="presentation" onClick={() => aprrovedHost({ id: item._id, status: "2" })}>
                                      <Link role="menuitem" tabIndex={-1} to="">Reject</Link>
                                    </li>
                                  </>
                                )}
                                {item?.status == 1 && (
                                  <li role="presentation" onClick={() => aprrovedHost({ id: item._id, status: "2" })}>
                                    <Link role="menuitem" tabIndex={-1} to="">Reject</Link>
                                  </li>
                                )}
                                {item?.status == 2 && (
                                  <li role="presentation" onClick={() => aprrovedHost({ id: item._id, status: "1" })}>
                                    <Link role="menuitem" tabIndex={-1} to="">Approve</Link>
                                  </li>
                                )}
                              </ul>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* Pagination */}
                <div className="row">
                  <div className="col-md-5">
                    <ul className="pagination">
                      <li className={`page-item ${currentPage == 1 ? "disabled" : ""}`}>
                        <button onClick={() => paginate(currentPage - 1)} className="page-link" disabled={currentPage == 1}>Previous</button>
                      </li>
                      <li className="page-item disabled">
                        <span className="page-link">{currentPage} / {totalPages}</span>
                      </li>
                      <li className={`page-item ${currentPage == totalPages ? "disabled" : ""}`}>
                        <button onClick={() => paginate(currentPage + 1)} className="page-link" disabled={currentPage == totalPages}>Next</button>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-5">
                    <div className="total-entries" style={{ float: "right", marginTop: "20px" }}>
                      Total entries: <b>{totalEntries}</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AppHost;
